module.exports = __webpack_public_path__ + "static/media/keyboard-arrow-right-24px.12dedc6f.svg";